<template>
  <div class="bulkImportExaminee">
    <el-dialog
      title="批量导入考生"
      :visible.sync="dialogBoxVisible"
      @closed="cancelRemove"
    >
      <div class="dialogBox">
        <el-input
          v-model.trim="selectFile"
          autocomplete="off"
          readonly
        ></el-input>
        <el-button @click="selectFileData()">选择文件</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传excel文件，且不超过10MB
        </div>
        <input
          type="file"
          id="files"
          ref="refFile"
          style="display: none"
          v-on:change="fileLoad"
        />
      </div>
      <div class="downloadExcel">
        <a href="examTest.xlsx" target="_self" download="批量导入考生模板.xls"
          >下载excel模板</a
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRemove">取 消</el-button>
        <el-button type="primary" @click="uploadSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as xlsx from "xlsx";
import loginvuex from "@/store/index";
import systemclass from "@/api/systemclassification";
export default {
  data() {
    return {
      dialogBoxVisible: false,
      selectFile: "", // 选择文件
      tableData: [],
    };
  },
  props: ["groupID"],
  methods: {
    cancelRemove() {
      this.dialogBoxVisible = false;
      this.$refs.refFile.value = "";
      this.selectFile = "";
    },
    // 选择文件
    selectFileData() {
      this.$refs.refFile.dispatchEvent(new MouseEvent("click"));
    },
    // 选择本地文件
    fileLoad() {
      const selectedFile = this.$refs.refFile.files[0];
      if (!selectedFile) {
        this.selectFile = "";
        return;
      }
      let excelType = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (excelType.indexOf(selectedFile.type) == -1) {
        this.selectFile = "";
        this.$message.warning("请上传excel文件");
        return;
      }
      //选中文件的文件名
      var name = selectedFile.name;
      //选中文件的大小
      var size = (selectedFile.size / (1024 * 1024)).toFixed(2);
      if (size > 10) {
        this.$message.warning("文件的大小不能大于10M");
        return;
      }
      this.selectFile = name;
      return true;
    },
    //上传提交
    async uploadSubmit() {
      this.tableData = [] // 防止历史缓存
      const file = this.$refs.refFile.files[0];
      if (!file) {
        this.$message.error("文件不存在");
        return;
      }
      if (!this.fileLoad()) {
        return;
      }
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = xlsx.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = xlsx.utils.sheet_to_json(worksheet, { header: 1 });
        // 提取文件内容
        let headers = jsonData[1];
        console.log(jsonData.slice(1),'jsonData.slice(2)',jsonData);

        jsonData.slice(1).forEach((row) => {
          if(row && row.length){
            this.tableData.push(row[1]?row[1]:row[0]);
          }
        });
        console.log(this.tableData);
        if (this.tableData.length == 0) {
          // 当前无数据
          this.$message({
            message: "警告，未找到正确的账号数据，请检查后重试",
            type: "warning",
          });
        } else {
          const obj = {
            groupID: this.groupID,
            userNameArr: JSON.stringify(this.tableData),
            hid: JSON.parse(loginvuex.state.userlist).hid,
          };
          const Data = await systemclass.importUser2Group(obj);
          console.log(Data.data.Status, Data.data.Data);
          if (Data.data.Status == 200) {
            this.dialogBoxVisible = false;
            this.$message({
              message: `恭喜你，批量成功导入了${this.tableData.length}条数据`,
              type: "success",
            });
            this.$parent.memberManageListData();
          } else if (Data.data.Status == 203) {
            let txt = "";
            if (Data.data.Data.length == 1) {
              txt = `存在账号${Data.data.Data[0]?.UserName || Data.data.Data[0]}未归属该医院，请检查后重新导入`;
            } else {
              txt = `存在账号${Data.data.Data[0]?.UserName || Data.data.Data[0]}等${Data.data.Data.length}个账号未归属该医院，请检查后重新导入`;
            }
            this.$alert(txt, "温馨提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.dialogBoxVisible = false;
              },
            });
          } else {
            this.$message.error(Data.data.Msg+Data.data.Data);
            this.dialogBoxVisible = false;
          }
        }

        // jsonData.forEach((json) => {
        //   //判断数据中有什么字段
        //   let keys = Object.keys(json);
        //   let data = {
        //     userName: keys.includes("考生账号") ? json["考生账号"] : null,
        //     realName: keys.includes("考生姓名") ? json["考生姓名"] : null,
        //     department: keys.includes("考生科室") ? json["考生科室"] : null,
        //     PTitle: keys.includes("职称") ? json["职称"] : null,
        //     Position: keys.includes("职位") ? json["职位"] : null,
        //     Birthday: keys.includes("出生日期")
        //       ? time2YMD(json["出生日期"])
        //       : null,
        //     JobDate: keys.includes("入职日期")
        //       ? time2YMD(json["入职日期"])
        //       : null,
        //   };
        //   this.tableData.push(data);
        // });
      };
      reader.readAsArrayBuffer(file);
      return;
      const obj = {
        groupID: this.groupID,
        userNameArr: JSON.stringify(this.tableData),
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await systemclass.importUser2Group(obj);
      console.log(data);

      return;
      try {
        //读取excel文件内容
        const dataBinary = await readFile(file.raw);
        const workbook = xlsx.read(dataBinary, {
          type: "binary",
          cellDates: true,
        });
        const table_0 = workbook.SheetNames[0];
        const jsonData = xlsx.utils.sheet_to_json(workbook.Sheets[table_0]);
        jsonData.forEach((json) => {
          //判断数据中有什么字段
          let keys = Object.keys(json);
          let data = {
            userName: keys.includes("考生账号") ? json["考生账号"] : null,
            realName: keys.includes("考生姓名") ? json["考生姓名"] : null,
            department: keys.includes("考生科室") ? json["考生科室"] : null,
            PTitle: keys.includes("职称") ? json["职称"] : null,
            Position: keys.includes("职位") ? json["职位"] : null,
            Birthday: keys.includes("出生日期")
              ? time2YMD(json["出生日期"])
              : null,
            JobDate: keys.includes("入职日期")
              ? time2YMD(json["入职日期"])
              : null,
          };
          userList.push(data);
        });
        console.log(userList);
        this.isLoading = false;
        this.userData = userList;
      } catch (e) {
        console.log(e);
        return false;
      }
      return;
      // 校验上传的文件
      //   const selectedFile = this.$refs.refFile.files[0];
      if (!selectedFile) {
        this.$message.error("文件不存在");
        return;
      }
      if (!this.fileLoad()) {
        return;
      }
      // 构建表单参数
      const uploadParam = new FormData();
      uploadParam.append("UserID", parseInt(this.$store.state.userID));
      uploadParam.append("id", "WU_FILE_0");
      uploadParam.append("name", selectedFile.name);
      uploadParam.append("type", selectedFile.type);
      uploadParam.append("lastModifiedDate", selectedFile.lastModifiedDate);
      uploadParam.append("size", selectedFile.size);
      uploadParam.append("file", selectedFile);
    },
  },
};
</script>

<style lang="scss" scoped>
// 弹框头部样式
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

::v-deep .dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button:nth-child(1) {
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
  }
  .el-button:nth-child(2) {
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
    margin-left: 50px;
  }
}
::v-deep .height743 {
  .el-dialog {
    width: 537px;
    height: 720px !important;
    // border: 1px solid red;
    border-radius: 5px 5px 0px 0px;
  }
}
::v-deep .examBox .el-dialog {
  width: 577px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}

::v-deep .examBox .el-input {
  width: 380px;
}

::v-deep .examBox .el-form-item label {
  width: 100px !important;
  text-align: left;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  font-family: "Microsoft YaHei";
}

.dialogBox {
  position: relative;
  margin-left: 24px;
}

.dialogBox .el-button {
  left: 380px;
  position: absolute;
  width: 114px;
  height: 40px;
  background: #1890ff;
  opacity: 1;
  border-radius: 4px;
  color: white;
}

// 批量导入考生
.bulkImportExaminee {
  display: flex;
  align-items: center;
}
::v-deep .el-dialog {
  width: 600px;
  height: 289px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}
::v-deep .el-input__inner {
  width: 350px !important;
}
.bulkImportExaminee .downloadExcel {
  text-decoration: underline;
  width: 91px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #1890ff;
  opacity: 1;
  margin-left: 24px;
  margin-top: 25px;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .deleteBatches .el-dialog {
  width: 421px;
  // height: 211px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
  p {
    line-height: 24px;
  }
}

.el-switch__core {
  width: 50px;
  height: 24px;
  background: #1890ff;
  opacity: 1;
  border-radius: 100px;
}

// 注册流程
::v-deep .examflow .el-dialog {
  width: 856px;
  height: 475px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}

.examflow .code {
  font-family: PingFang SC;
  font-size: 21px;
  font-weight: bold;
  line-height: 21px;
  color: #333333;
  opacity: 1;
  text-align: center;
  margin-top: -32px;
}

.examflow {
  margin-top: 30px;
  .examflowfirm {
    display: flex;
    flex-direction: column;
    .imgShow {
      margin-top: 30px;
      .imgTxt {
        width: 216px;
        height: 100px;
        font-size: 18px;
        color: #ffffff;
        position: relative;
        background-image: url("../../../../assets/examFlow/flow1.png");
        background-repeat: no-repeat;
        float: left;
        background-size: cover;
      }
      .imgTxt2 {
        width: 216px;
        height: 100px;
        font-size: 18px;
        color: #ffffff;
        position: relative;
        background-image: url("../../../../assets/examFlow/flow2.png");
        background-repeat: no-repeat;
        float: left;
        background-size: cover;
      }
      .imgTxt3 {
        width: 216px;
        height: 100px;
        font-size: 18px;
        color: #ffffff;
        position: relative;
        background-image: url("../../../../assets/examFlow/flow3.png");
        background-repeat: no-repeat;
        float: left;
        background-size: cover;
      }
      .imgIcon {
        width: 84px;
        height: 100px;
        position: relative;
        float: left;
        font-size: 30px;
        color: #1890ff;
        justify-content: center;
        align-items: center;
        align-content: space-between;
        display: flex;
      }
    }
    .hint {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 26px;
      color: #333333;
      opacity: 1;
      position: relative;
      float: left;
      margin-top: 46px;
      display: flex;
      flex-direction: column;
    }
    .dialog-footer {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 26px;
      color: #333333;
      opacity: 1;
      position: relative;
      float: left;
      margin-top: 46px;
      display: flex;
      ::v-deep .el-button {
        &:nth-child(2) {
          margin-left: 30px;
        }
      }
    }
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.el-input__inner {
  width: 300px;
}
</style>